import { Paper, MenuItem, styled } from '@mui/material';

export const StyledMenuPaper = styled(Paper)(({ theme }) => ({
  width: 'fit-content',
  minWidth: 160,
  maxWidth: 280,
  overflow: 'hidden',
  borderRadius: theme.spacing(1), // 4px
  boxShadow: '0px 1px 3px rgba(0,0,0,0.30)',
  backgroundColor: theme.palette.menu.background,
  display: 'inline-flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  height: 48,
  paddingLeft: theme.spacing(2), // 16px
  paddingRight: theme.spacing(2), // 16px
  backgroundColor: theme.palette.menu.background,
  '&:hover': {
    backgroundColor: theme.palette.menu.itemHover,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.menu.background,
    opacity: 0.6,
  },
}));
